import React, { useState, useEffect } from "react";
import SupportersInfo from "./SupportersInfo";
import { ReactComponent as Trash } from "../../../../Assets/Image/svg/trash.svg";
import { ReactComponent as Edit } from "../../../../Assets/Image/svg/edit.svg";
import EmptyCourseDash from "../../../share/EmptyCourseDash/EmptyCourseDash";
import { Modal } from "../../../share/modal/Modal";
import { BsArrowLeft } from "react-icons/bs";
import { BtnPrimary } from "../../../share/buttons/Btn";
import { BsArrowRight } from "react-icons/bs";
import { ReactComponent as TicketDot } from "../../../../Assets/Image/svg/ticketDot.svg";
import MainPagination from "../../../../Components/share/Pageination/MainPagination";
import useFetch from "../../../../Hooks/useFetch";
import IconButton from "../../../share/buttons/IconButton";
import { useCreate } from "../../../../Context/CreateContext";

const CreateCourseSupporters = (props) => {
    const { phaseStatus, setPhaseStatus, bootCamp } = useCreate();

    const [ticketInfo, setTicketInfo] = useState(false);
    const [upload, setUpload] = useState(false);
    const [emptyPage, setEmptyPage] = useState(false);
    const [supports, setSupports] = useState();
    const [del, setDel] = useState();
    const [edit, setEdit] = useState();
    const [pagination, setPagination] = useState({
        current: 1,
    });

    const handleModal = () => {
        setUpload((perv) => !perv);
    };
    const handlePage = () => {
        setEmptyPage((perv) => !perv);
    };

    const getSupporter = useFetch({
        method: "GET",
        url: `BootCampSupporterService/${bootCamp?.id}/supporters`,
        pagination: pagination,
        noHeader: false,
        trigger: true,
        setter: setSupports,
    });

    const deleteSupporter = useFetch({
        method: "DELETE",
        url: `BootCampSupporterService/${del}`,
        noHeader: false,
        caller: getSupporter,
    });

    useEffect(() => {
        getSupporter.reFetch();
    }, [pagination]);

    const handleDelete = (id) => {
        setDel(id);
        deleteSupporter.reFetch();
    };
    const handleEdit = (id) => {
        setEdit(id);
        setUpload((perv) => !perv);
    };

    return (
        <div className=" mt-20">
            {supports?.results.length !== 0 ? (
                <>
                    <div className="flex justify-between items-center mb-20">
                        <h4 className="text-[2rem] text-purple-dark font-bold">
                            اطلاعات برگزارکنندگان و حامیان بوت کمپ
                        </h4>
                        <BtnPrimary
                            text="+ افزودن برگزارکننده و حامی"
                            className="px-16 py-7"
                            onClick={(e) => handleModal()}
                        />
                    </div>
                    <div className=" rounded-3xl overflow-hidden border-2 border-solid border-light-prim2">
                        <div className="accessibility-card accessibility-body bg-purple-dark-1 mb-4 font-bold text-black-prim">
                            <div>لوگو</div>
                            <div>نام</div>
                            <div>سمت</div>
                            <div>وب‌سایت</div>
                            <div></div>
                        </div>
                        {supports?.results.map((i) => (
                            <div
                                key={i.id}
                                className="accessibility-card accessibility-body  my-4 relative"
                            >
                                <div className=" ">
                                    <img src={i.supporter_logo} />
                                </div>
                                <div className=" text-black-prim">
                                    {i.supporter_name}
                                </div>
                                <div>
                                    <p>حامی</p>
                                </div>
                                <div className=" text-purple-dark cursor-pointer">
                                    {i.supporter_website}
                                </div>
                                <div className="">
                                    {!i.checked && (
                                        <div className=" text-left flex gap-x-16 justify-center">
                                            <IconButton
                                                data-tip="حذف"
                                                onClick={() =>
                                                    handleDelete(i.id)
                                                }
                                            >
                                                <Trash />
                                            </IconButton>
                                            <IconButton
                                                data-tip="ویرایش"
                                                onClick={() => handleEdit(i.id)}
                                            >
                                                <Edit />
                                            </IconButton>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                    <MainPagination
                        pagination={pagination}
                        setPagination={setPagination}
                        data={supports?.results}
                        pageSize={supports?.page_count}
                        className="mt-[3rem]"
                    />
                    <div className="flex  justify-between items-center mt-20">
                        <div
                            className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
                            onClick={props.prevStep}
                        >
                            <span>مرحله قبل</span>
                            <BsArrowRight />
                        </div>
                        <div
                            className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
                            onClick={props.nextStep}
                        >
                            <span>ثبت و ادامه</span>
                            <BsArrowLeft />
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <EmptyCourseDash name="حامی" show={setUpload} />
                </>
            )}
            <Modal show={upload} closeModal={handleModal}>
                <SupportersInfo
                    close={handleModal}
                    getSupporter={getSupporter}
                    edit={edit}
                    setEdit={setEdit}
                />
            </Modal>
        </div>
    );
};

export default CreateCourseSupporters;

const discounts = [
    { name: "بلیت زودهنگام", price: "20000", code: 20 },
    { name: "بلیت زودهنگام", price: "20000", code: 20 },
    { name: "بلیت زودهنگام", price: "20000", code: 20 },
];
